import elementExists from "../lib/elementExists";

const HeroSection = function () {
    const linkWrapBlocks = document.querySelectorAll( '.link-wrap__block')
    if( elementExists( linkWrapBlocks , true )){
      linkWrapBlocks.forEach( function( block ){
        block.addEventListener( 'mouseenter' , function( event ){
          linkWrapBlocks.forEach( function( _block ){
            _block.classList.add( 'fade');
          })
          block.classList.remove( 'fade');
        })
        block.addEventListener( 'mouseleave' , function(_block ){
          linkWrapBlocks.forEach( function( _block ){
            _block.classList.remove( 'fade');
          })
        })
      });
    }
}

export default HeroSection;
